import React, { useMemo } from 'react';
import useVehicleWarrantyInformation from './hooks/useVehicleWarrantyInformationReport';
import VehicleWarrantyInformationTable from './components/VehicleWarrantyInformationTable';
import VehicleWarrantyInformationFilter from './components/VehicleWarrantyInformationFilter';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useLazyExportVehicleWarrantyInformationToExcelQuery } from '../../../api/endpoints/vehicleWarrantyInformationReport';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';


const columns = (th) => [
  {field:'zNumber',header:th('vehicleWarrantyInformation.columns.ZNumber')},
  { field: 'sasiNo', header: th('vehicleWarrantyInformation.columns.SasiNo') },
  { field: 'garantiTipi', header: th('vehicleWarrantyInformation.columns.GarantiTipi') },
  { field: 'strWarranty', header: th('vehicleWarrantyInformation.columns.StrWarranty') },
  { field: 'extWarranty', header: th('vehicleWarrantyInformation.columns.ExtWarranty') },
  { field: 'zMonth', header: th('vehicleWarrantyInformation.columns.ZMonth') },
  { field: 'mileage', header: th('vehicleWarrantyInformation.columns.Mileage') },
  { field: 'cost', header: th('vehicleWarrantyInformation.columns.Cost') },
  { field: 'waers', header: th('vehicleWarrantyInformation.columns.Waers') },
  { field: 'fullName', header: th('vehicleWarrantyInformation.columns.FullName') },
  { field: 'satisTarihi', header: th('vehicleWarrantyInformation.columns.SatisTarihi'), dataType: 'date' },
  { field: 'garantiBaslangic', header: th('vehicleWarrantyInformation.columns.GarantiBaslangic'), dataType: 'date' },
  { field: 'garantiBitis', header: th('vehicleWarrantyInformation.columns.GarantiBitis'), dataType: 'date' },
];


export default function VehicleWarrantyInformationPage() {
    const { th } = useLanguage();

    const { 
        items, 
        totalCount, 
        isFetching, 
        lazyParams, 
        onPage, 
        applyFilters, 
        resetFilters ,
        hasApplied,
        exportParams
    } = useVehicleWarrantyInformation();

    const tableColumns = useMemo(() => columns(th), [th]);

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleWarrantyInformation.title')}</h1>
                    <GenericFileExportButton
                        useExportQuery={useLazyExportVehicleWarrantyInformationToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        disabled={!hasApplied || items.length === 0}
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'arac_garanti_bilgileri.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
            </div>

            <VehicleWarrantyInformationFilter onApplyFilters={applyFilters} onResetFilters={resetFilters} />

            {items && items.length > 0 && (
                <div className="mt-3">
                    <VehicleWarrantyInformationTable items={items} totalCount={totalCount} loading={isFetching} lazyParams={lazyParams} onPage={onPage} columns={tableColumns} />
                </div>
            )}

            {!isFetching && hasApplied && items.length === 0 && (
                <div className="flex justify-content-center align-items-center p-5">
                    <p className="text-500">{th('common.noRecords')}</p>
                </div>
            )}
        </div>
    );
}